import AccountHead from "./AccountHead/";
import Groups from "./Groups";
import DayBook from "./DayBook";
import LedgerBook from "./LedgerBook";
import PartyRate from "./PartyRate";
import RouteDetails from "./RouteDetails";
export default {
  AccountHead,
  Groups,
  DayBook,
  LedgerBook,
  PartyRate,
  RouteDetails,
};
